import { Env } from 'src/app/constants/eyeforest-modules';
import { Theme } from '../app/services/theme.service';

export const environment = {
  production: false,
  api: {
    url: 'https://railgis-1-0.eyeforest.dev/',
    eyeforestURL: 'https://rail-1-0-api.eyeforest.dev/',
  },
  URL_WMS_BASE: 'https://177.93.108.146:9556/geoserver/mapforest/wms',
  URL_WMS_LAYER: 'https://177.93.108.146:9556/geoserver/mapforest/wms',
  TILE_LAYER_VERSION: '1.1.1',
  TILE_WMS_VERSION: '1.1.0',
  SUPERSET_URL: 'https://rail-1-0-superset.eyeforest.dev',
  mapbox: {
    accessToken: 'pk.eyJ1Ijoia2VsdmluZm9yZXN0b2tlbiIsImEiOiJjbWc2amZycmcwZjg2MmpxMG95bm96YTB0In0.iFMkCVAJlUcJSU9VNbjULg',
    user: 'mapbox',
  },
  DEMO_ARBOR_CHATBOT_URL: 'https://rail-1-0-arbor.eyeforest.dev/',
  KEYCLOAK_URL: 'https://rail-1-0-id.eyeforest.dev',
  NATS: { 
    URL: 'wss://rail-1-0-nats.eyeforest.dev/',
    USERNAME: 'public',
    PASSWORD: 'Improve-Mad-Wish-Unless-4'
  },
  THEME: Theme.RailGIS,

  eyeforestModulesDomain: Env.Dev, // local, dev, prod, demo2
};
